import { render, staticRenderFns } from "./AuthenticationLayout.vue?vue&type=template&id=5aaa08d0&"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=js&"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports